// Footer.js
import React from 'react';
import './Footer.css'; // File CSS per lo stile del footer

const Footer = () => {
    return (
        <footer className="main-footer">
            <p>©2024 Ri.Ma. Tutti i diritti riservati.</p>
        </footer>
    );
};

export default Footer;